<template>
  <div :style="{width:params.width,height:(params.height||'100%'),padding:params.padding}" style="overflow:auto;">
    <mw-inner-page noWrap v-if="params.type==='page'" :pageId="pageId" :pageData="params.pageData" :params="params" ref="innerPage"></mw-inner-page>
    <comp-wrapper v-if="params.type==='comp' && params.template" :params="params"></comp-wrapper>
  </div>
</template>

<script>
    export default {
        name: "item-wrapper",
        props:["params","data","idField"],
        mounted() {

        },
        computed:{
          pageId(){
            return this.idField && this.params[this.idField] ||  this.params.pageId
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/item-wrapper.vue